import { render } from "./report.vue?vue&type=template&id=566fef14&scoped=true"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"

import "./report.vue?vue&type=style&index=0&id=566fef14&lang=scss&scoped=true"

import exportComponent from "D:\\codes\\chat28\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566fef14"]])

export default __exports__